// UWAGA: Wykorzystane w OPAC
import BsBaseController from './_base_controller'
import Modal from 'bootstrap/js/src/modal'

// usage:
//  through "_modal" partial
export default class extends BsBaseController {
  _setAttributes () {
    // attributes not required
    // aria-controls not valid for btn opening modal
  }

  _createBsComponent () {
    return new Modal(this.element)
  }

  show () { this._bsComponent.show() }
  hide () { this._bsComponent.hide() }
}
